<script setup lang="ts">
defineProps<{
  title?: string;
  isCollapsable?: boolean;
}>();

type Emits = {
  (e: "show-less"): void;
  (e: "show-more"): void;
};

const emit = defineEmits<Emits>();

type Slots = {
  content?(props: { isCollapsed: boolean }): HTMLElement;
  showLess?(): HTMLElement;
  showMore?(): HTMLElement;
};

defineSlots<Slots>();

const isCollapsed = ref(false);
const onCollapseButtonClicked = () => {
  const newIsCollapsed = !isCollapsed.value;
  isCollapsed.value = newIsCollapsed;

  if (newIsCollapsed) {
    emit("show-more");
  } else {
    emit("show-less");
  }
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <h2
      v-if="title"
      class="uppercase text-2xl"
    >
      {{ title }}
    </h2>
    <slot
      name="content"
      :is-collapsed="isCollapsed"
    />
    <button
      v-if="isCollapsable"
      type="button"
      class="flex items-center mt-2 uppercase text-platform-text-1 font-semibold gap-1"
      @click="onCollapseButtonClicked"
    >
      <slot
        v-if="isCollapsed"
        name="showLess"
      >
        {{ $t("common.showLess") }}
      </slot>
      <slot
        v-else
        name="showMore"
      >
        {{ $t("common.showMore") }}
      </slot>
      <BaseAnimatedChevronIcon :direction="isCollapsed ? 'up' : 'down'" />
    </button>
  </div>
</template>
